export class ContentStackWeb {
  getRequestPayloadWeb() {
    return {
      query: {
        getWebContent: {
          homeBanner: {
            entries: {
              uid: true,
              title: true,
              description: true,
              linkTitle: true,
              linkHref: true,
              image: {
                uid: true,
                title: true,
                filename: true,
                url: true,
                altTxt: true
              }
            }
          },
          webHomePage: {
            sectionTitle: true,
            entries: {
              uid: true,
              title: true,
              description: true,
              moreDescription: true,
              createdAt: true
            }
          },
          siteNews: {
            entries: {
              uid: true,
              title: true,
              description: true,
              moreDescription: true,
              createdAt: true,
              expirationDate: true,
              subHeading: true,
              image: {
                uid: true,
                title: true,
                filename: true,
                url: true,
                altTxt: true
              }
            }
          },
          webFooter: {
            entries: {
              uid: true,
              copyRight: true,
              policyVersion: true,
              logo: {
                uid: true,
                title: true,
                filename: true,
                url: true
              },
              socialLinks: {
                uid: true,
                title: true,
                filename: true,
                url: true,
                hrefLink: true
              }
            }
          }
        }
      }
    };
  }
}
